///
/// EarthBrowser
///
/// Created by Matt Giger on December 14, 2025
/// Copyright (c) 2025 Geodata Labs
///

import { useEffect, useState } from 'react'
import { CommandRegistry, type CommandRegistration, type BrowserFeature } from '@/components/features/CommandRegistry'

/**
 * Hook to access command registry and subscribe to changes
 */
export function useCommandRegistry() {
  const [commands, setCommands] = useState<CommandRegistration[]>(() => CommandRegistry.getCommands())
  const [features, setFeatures] = useState<BrowserFeature[]>(() => CommandRegistry.getFeatures())

  useEffect(() => {
    const updateState = () => {
      const newCommands = CommandRegistry.getCommands()
      const newFeatures = CommandRegistry.getFeatures()
      setCommands(newCommands)
      setFeatures(newFeatures)
    }

    const unsubscribe = CommandRegistry.subscribe(updateState)

    // Immediately fetch any features that were already registered
    // (This handles the race condition where child features register before we subscribe)
    updateState()

    return unsubscribe
  }, [])

  return {
    commands,
    features,
    registerFeature: CommandRegistry.registerFeature.bind(CommandRegistry)
  }
}

